import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import SizePopup from './size-popup';

const OptionSelector = ({
  option,
  selectedOptions,
  inventoryMessage,
  product,
  chartPopup,
  sizeLimit,
  isStylitics,
  optionId,
  handleOptionChange,
  availableValues,
  currentVariant,
}) => (
  <Fragment>
    <div className="flex justify-between">
      <p className="flex body-3 mb-2.5">
        {window.TMW.Strings.product.selectOption}{' '}
        {option.name?.toLowerCase() || option?.toLowerCase()}
        :&nbsp;
        <span className="font-medium">
          {
            selectedOptions?.find((item) => item.name?.toLowerCase() === 'size')
              ?.value
          }
        </span>
        {inventoryMessage.inventoryMessage()}
      </p>
      <SizePopup data={product} chartPopup={chartPopup} />
    </div>
    <div
      className={`flex flex-wrap gap-2 mb-1`}
      data-options-product={product.id}
    >
      {option.values.map((value, index) => {
        // eslint-disable-next-line max-len
        const uniqueID = `${index}_${product.id}_${optionId}-${value}-${isStylitics}`;
        const isAvailable = availableValues.includes(value);
        const shouldHide =
          Boolean(product.hideAddToCart) && currentVariant?.availableForSale;

        const [isReady, setIsReady] = useState(false);
        useEffect(() => {
          const timer = setTimeout(() => {
            setIsReady(true);
          }, 100);
          return () => clearTimeout(timer);
        }, []);

        return (
          (sizeLimit ? index < sizeLimit : true) && (
            <div className="relative" key={uniqueID}>
              {!isReady ? (
                <div className="w-full h-[41px] bg-gray-200"></div>
              ) : (
                <div className="transition-opacity duration-500 opacity-100">
                  <input
                    className="bg-transparent border-transparent absolute z-1 block w-full h-full rounded-none peer focus:!border
                  focus:!border-blue-500 checked:!bg-transparent checked:hover:bg-transparent focus:bg-transparent"
                    name={`${product.id}_${optionId}`}
                    id={uniqueID}
                    value={value}
                    checked={
                      selectedOptions?.find(
                        (item) =>
                          item.value?.toLowerCase() === value?.toLowerCase(),
                      )?.value === value
                    }
                    type="radio"
                    onChange={() =>
                      handleOptionChange({ name: option.name, value })
                    }
                    onClick={() =>
                      handleOptionChange({ name: option.name, value })
                    }
                    data-option-name={option.name}
                    data-value={value}
                  />
                  <label
                    className={`border-1 overflow-hidden h7 relative mb-0
                    -mt-[1px] -ml-[1px] flex cursor-pointer items-center
                    justify-center border peer-checked:z-2
                    px-2 peer-checked:border-black
                    min-w-[41px] h-[41px] border-gray-400 focus:outline
                    focus:outline-blue-400
                   ${
                     shouldHide || !isAvailable
                       ? 'bg-gray-1 text-gray-6 text-gray-500'
                       : 'bg-white'
                   }`}
                    htmlFor={uniqueID}
                  >
                    {value}

                    {(shouldHide || !isAvailable) && (
                      <span className="crossed-line absolute text-gray-400 z-2 h-full w-full"></span>
                    )}
                  </label>
                </div>
              )}
            </div>
          )
        );
      })}
    </div>
  </Fragment>
);

export default OptionSelector;
